<script setup>
// Club-page cell for an Americano league. X213: "Americano league · Padel · 16 players" / "… · No cycle running"
// from the shown cycle (utils/competitionCard.js), never a bare "0 players" between cycles.
import {computed} from 'vue';
import ClickableCell from '@/components/lists/ClickableCell';
import {americanoCardLine} from '~/utils/competitionCard';

const props = defineProps({
  americano: {
    type: Object,
    default: () => null
  },
  timeZone: {
    type: String,
    default: null
  }
});

const subtitle = computed(() => americanoCardLine(props.americano, {timeZone: props.timeZone}));
</script>

<template>
  <clickable-cell
      icon="mdi-account-switch"
      tone="americano"
      class="mb-3"
      :to="{ name: 'AmericanoDetail', params: { americanoId: americano.id } }"
      :title="americano.name"
      :subtitle="subtitle"
      subtitle-one-line
  />
</template>
